import * as Yup from "yup";

const passwordRules = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;

export const memberLoginSchema = Yup.object().shape({
  identifier: Yup.string().trim().required("Email, phone, CNIC or member code is required."),
  password: Yup.string().required("Password is required."),
});

export const memberChangePasswordSchema = Yup.object().shape({
  currentPassword: Yup.string().required("Current password is required."),
  newPassword: Yup.string()
    .min(8, "Password must be at least 8 characters.")
    .matches(passwordRules, {
      message: "Password must contain at least 1 uppercase, 1 lowercase and 1 number.",
    })
    .required("New password is required."),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword"), null], "Passwords must match.")
    .required("Confirm password is required."),
});

export const adminResetMemberPasswordSchema = Yup.object().shape({
  newPassword: Yup.string()
    .min(8, "Password must be at least 8 characters.")
    .matches(passwordRules, {
      message: "Password must contain at least 1 uppercase, 1 lowercase and 1 number.",
    })
    .required("New password is required."),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword"), null], "Passwords must match.")
    .required("Confirm password is required."),
});
